import React from "react";
import i18n from "i18next";

const LanguageSwitcher = ({changeLanguage}) => {
    return (
        <div className="btn-group switcher-lang">
            <button className={`btn btn-outline-secondary ${i18n.language === 'pl' ? 'active' : ''}`} onClick={() => changeLanguage('pl') }> PL</button>
            <button className={`btn btn-outline-secondary ${i18n.language === 'en' ? 'active' : ''}`} onClick={() => changeLanguage('en') }> EN</button>
        </div>
    )
}
export default LanguageSwitcher;